<template>
  <div class="details_content_all">
    <div class="details_content_repeat">
      <QS-h4-title title="订单关联信息" />
      <div class="details_content_repeat_hundred">
        <el-form label-width="102px">
          <column-box :source="baseInfo" :list="baseInfoList" label-width="140">
          </column-box>
        </el-form>
      </div>
    </div>
    <div class="details_content_repeat">
      <QS-h4-title title="订单关联记录" />
      <div class="details_content_repeat_hundred">
        <!--bodyList 表格请求的数据-->
        <QS-common-table
          :data="tableData"
          :columns="tableColumns"
          :pagination="pagination"
          @change="paginationChange"
        ></QS-common-table>
      </div>
    </div>
  </div>
</template>
<script>
import { getRelationList } from '@/api/financeApi'
import selectOption from '@/store/dict/selectOptionDict'

export default {
  name: 'OrderRelated',
  data() {
    return {
      loading: false,
      baseInfo: {
        relationContract: '',
        relationReason: '',
        relationRemark: '',
      },
      baseInfoList: [
        {
          key: 'relationContract',
          name: '是否关联订单',
        },
        {
          key: 'relationReason',
          name: '关联原因',
        },
        {
          key: 'relationRemark',
          name: '关联说明',
        },
      ],
      tableColumns: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '关联记录ID',
            width: 120,
          },
        },
        {
          name: 'relationReason',
          columnProps: {
            prop: 'relationReason',
            label: '关联原因',
            width: 110,
          },
          getText: ({ row }) => selectOption.rderRelatedReason[row.relationReason],
        },
        {
          name: 'oldContractId',
          columnProps: {
            prop: 'oldContractId',
            label: '原订单ID',
          },
          render: ({ row }) => (
            <el-link
              href={`/workbench/rentOrder/detail?id=${row.oldContractId}`}
              target="_blank"
              type="primary">
            { row.oldContractId }</el-link>
          ),
        },
        {
          name: 'oldContractState',
          columnProps: {
            prop: 'oldContractState',
            label: '原订单状态',
            width: 120,
          },
        },
        {
          name: 'oldContractPlateNo',
          columnProps: {
            prop: 'oldContractPlateNo',
            label: '原订单车牌号',
            width: 140,
          },
        },
        {
          name: 'oldContractCustomerName',
          columnProps: {
            prop: 'oldContractCustomerName',
            label: '原订单客户',
            width: 120,
          },
        },
        {
          name: 'newContractId',
          columnProps: {
            prop: 'newContractId',
            label: '新订单ID',
          },
          render: ({ row }) => (
            <el-link
              href={`/workbench/rentOrder/detail?id=${row.newContractId}`}
              target="_blank"
              type="primary"
            >{ row.newContractId }</el-link>
          ),
        },
        {
          name: 'newContractState',
          columnProps: {
            prop: 'newContractState',
            label: '新订单状态',
            width: 120,
          },
        },
        {
          name: 'newContractPlateNo',
          columnProps: {
            prop: 'newContractPlateNo',
            label: '新订单车牌号',
            width: 140,
          },
        },
        {
          name: 'newContractCustomerName',
          columnProps: {
            prop: 'newContractCustomerName',
            label: '新订单客户',
            width: 120,
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '关联记录创建时间',
            width: 160,
          },
        },
      ],
      // 关联数据
      tableData: [],
      pagination: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      orderId: '',
    }
  },
  inject: ['orderData'],
  watch: {
    orderData: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.orderId) {
          this.orderId = newVal.orderId
          this.relationList()
        }
      },
    },
  },
  methods: {
    // 获取订单关联信息
    async relationList() {
      this.loading = true
      try {
        const { code, data } = await getRelationList({
          contractId: this.orderId,
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
        })
        if (code === 1) {
          this.tableData = data.contractList.items.map((item) => {
            return {
              ...item,
              oldContractState: selectOption.leaseOrderState[item.oldContractState],
              newContractState: selectOption.leaseOrderState[item.newContractState],
              relationExplain: selectOption.rderRelatedReason[item.relationExplain],
            }
          })
          this.pagination.total = data.contractList.totalNum
          // 是否关联订单
          this.baseInfo.relationContract = data.relationContract
          // 关联原因
          this.baseInfo.relationReason =
            selectOption.rderRelatedReason[data.relationReason]
          // 关联说明
          this.baseInfo.relationRemark = data.relationRemark
          console.log(this.baseInfo, '----')
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageNum = pagination.pageNum
      this.paginationData.pageSize = pagination.pageSize
      this.relationList()
    },
  },
}
</script>

<style></style>
